/**
 * Auth Profile Duplicate Notification Container (Phase 9)
 * Polls for duplicate profiles and shows modal/toast when detected
 */

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AuthProfileDuplicateModal from './AuthProfileDuplicateModal';
import duplicateProfilePoller from '../../services/duplicateProfilePoller';
import axios from 'axios';

const AuthProfileDuplicateNotificationContainer = ({ proxySessionId, isDarkMode, onActionComplete }) => {
  const [pendingDuplicate, setPendingDuplicate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!proxySessionId) return;

    // Note: Auto-update toast notifications are now handled globally by GlobalAuthProfileNotifications
    // This component only handles the duplicate profile modal

    // Start polling for pending duplicates (ask mode)
    duplicateProfilePoller.start(proxySessionId, ({ duplicate, sessionId, duplicateIndex }) => {
      console.log('[DuplicateNotification] Duplicate detected:', duplicate);

      // Set the first pending duplicate and show modal
      setPendingDuplicate({ duplicate, sessionId, duplicateIndex });
      setShowModal(true);
    });

    return () => {
      duplicateProfilePoller.stop(proxySessionId);
    };
  }, [proxySessionId]);

  const handleClose = () => {
    setShowModal(false);
    setPendingDuplicate(null);
  };

  const handleActionComplete = (result) => {
    setShowModal(false);
    setPendingDuplicate(null);

    // Notify parent
    if (onActionComplete) {
      onActionComplete(result);
    }
  };

  if (!showModal || !pendingDuplicate) return null;

  return (
    <AuthProfileDuplicateModal
      duplicate={pendingDuplicate.duplicate}
      proxySessionId={pendingDuplicate.sessionId}
      duplicateIndex={pendingDuplicate.duplicateIndex}
      onClose={handleClose}
      onActionComplete={handleActionComplete}
      isDarkMode={isDarkMode}
    />
  );
};

export default AuthProfileDuplicateNotificationContainer;
